module.exports = __webpack_public_path__ + "img/process_2.380b2d49.png";